import React from 'react';

interface CreditGateProps {
  cost: number;
  balance: number;
  children: React.ReactNode;
}

/**
 * Wrapper that disables a button if the user doesn't have enough credits.
 * Shows a title tooltip indicating the cost and remaining balance.
 */
export function CreditGate({ cost, balance, children }: CreditGateProps) {
  const hasCredits = balance >= cost;
  const child = React.Children.only(children) as React.ReactElement<any>;
  const existingTitle = child.props.title;
  const costSuffix = `costs ${cost} credit${cost === 1 ? '' : 's'}`;

  if (!hasCredits) {
    const tooltipText = existingTitle
      ? `${existingTitle} — ${costSuffix} (you only have ${balance})`
      : `Costs ${cost} credit${cost === 1 ? '' : 's'} (you only have ${balance})`;
    return React.cloneElement(child, {
      disabled: true,
      'aria-disabled': true,
      title: tooltipText,
    });
  }

  const tooltipText = existingTitle ? `${existingTitle} — ${costSuffix}` : `Costs ${cost} credit${cost === 1 ? '' : 's'}`;
  return React.cloneElement(child, { title: tooltipText });
}
